module.exports = __webpack_public_path__ + "static/media/ev2.556fea1a.jpg";